import { IconContent } from '@icons';

export const arrowsIn: IconContent = {
    sm: '<path d="m6.06 9.04.34-.1-4.3 4.3.66.66 4.3-4.3-.1.34c-.09.32-.13.66-.13 1V14h.93V8.24H2v.93h3.05c.35 0 .69-.04 1.01-.13ZM9.94 6.96l-.34.1 4.3-4.3-.66-.66-4.3 4.3.1-.34c.09-.32.13-.66.13-1V2h-.93v5.76H14v-.93h-3.05c-.35 0-.69.04-1.01.13Z" />',
};
